/* eslint-disable max-lines */
// Grouping configuration based on your table data
export const abcSelectFieldsGrouping = [
  {
    name: 'ABSLI',
    code: 'ABSLI',
    defaultExpanded: false,
    fields: [
      'absli_fyp_individual_qu4p83wxh',
      'absli_fyp_individual_points',
      'absli_fyc_individual_0amsodvw1e',
      'absli_fyc_individual_points',
      'absli_aum_traditional_chw0gfq6vo',
      'absli_aum_traditional_points',
      'absli_aum_ulip_ru6jxvvlh',
      'absli_aum_ulip_points',
      'absli_fyp_term_ce29164mpp',
      'absli_fyp_term_points',
    ],
  },
  {
    name: 'ABHI',
    code: 'ABHI',
    defaultExpanded: false,
    fields: [
      'abhi_fyp_insurance_ff_input',
      'abhi_fyp_insurance_points',
      'abhi_fyp_group_session_context',
      'abhi_fyp_group_points',
    ],
  },
  {
    name: 'ABHFL',
    code: 'ABHFL',
    defaultExpanded: false,
    fields: ['abhfl_loan_disbursed_input_a', 'abhfl_loan_disbursed_points'],
  },
  {
    name: 'ABCL-NBFC',
    code: 'ABCL-NBFC',
    defaultExpanded: false,
    fields: [
      'abcl_loan_disbursed_c2vi4lxys8',
      'abcl_loan_disbursed_points',
      'abcl_ytd_outstanding_p79ec3vkpj',
      'abcl_ytd_outstanding_points',
    ],
  },
  {
    name: 'ABML',
    code: 'ABML',
    defaultExpanded: false,
    fields: [
      'abml_equity_derivatives_9x2k',
      'abml_equity_derivatives_points',
      'abml_pms_book_7p5m',
      'abml_pms_book_points',
    ],
  },
  {
    name: 'TOTAL',
    code: 'TOTAL',
    fields: ['total_select_points'],
  },
];

// Form configuration with all fields
export const abcSelectFields = [
  // ABSLI Fields
  {
    type: 'currency',
    code: 'absli_fyp_individual_qu4p83wxh',
    hint: 'First Year Premium (FYP) - Individual',
    required: false,
    max_chars: 19,
    read_only: false,
    display_in_form_type: 'MODULE',
    retain_form_context: true,
  },
  {
    type: 'decimal',
    code: 'absli_fyp_individual_points',
    hint: 'SELECT Points',
    required: false,
    read_only: true,
    display_in_form_type: 'MODULE',
    retain_form_context: true,
    default_value: {
      type: 'standard',
      inputs: [
        {
          type: 'value',
          value: {
            val_type: 'function',
            operator: null,
            operatorRequired: false,
            function: {
              type: 'standard',
              inputs: [
                {
                  type: 'value',
                  value: {
                    val_type: 'function',
                    operator: null,
                    operatorRequired: false,
                    function: {
                      type: 'standard',
                      inputs: [
                        {
                          type: 'value',
                          value: {
                            val_type: 'form',
                            operator: null,
                            operatorRequired: false,
                            attribute: 'absli_fyp_individual_qu4p83wxh',
                            inputField: 'absli_fyp_individual_qu4p83wxh',
                          },
                        },
                        {
                          type: 'value',
                          value: {
                            val_type: 'static',
                            operator: null,
                            operatorRequired: false,
                            value: 60,
                            dataType: 'number',
                          },
                        },
                      ],
                      standardFunction: 'DIVIDE',
                      output: null,
                      returnType: 'number',
                    },
                  },
                },
              ],
              standardFunction: 'ROUND',
              output: null,
              returnType: 'number',
            },
          },
        },
      ],
      standardFunction: 'IS',
      output: null,
      returnType: 'number',
    },
  },
  {
    type: 'currency',
    code: 'absli_fyc_individual_0amsodvw1e',
    hint: 'First Year Commission (FYC) - Individual',
    required: false,
    max_chars: 19,
    read_only: false,
    display_in_form_type: 'MODULE',
    retain_form_context: true,
  },
  {
    type: 'decimal',
    code: 'absli_fyc_individual_points',
    hint: 'SELECT Points',
    required: false,
    read_only: true,
    display_in_form_type: 'MODULE',
    retain_form_context: true,
    default_value: {
      type: 'standard',
      inputs: [
        {
          type: 'value',
          value: {
            val_type: 'function',
            operator: null,
            operatorRequired: false,
            function: {
              type: 'standard',
              inputs: [
                {
                  type: 'value',
                  value: {
                    val_type: 'function',
                    operator: null,
                    operatorRequired: false,
                    function: {
                      type: 'standard',
                      inputs: [
                        {
                          type: 'value',
                          value: {
                            val_type: 'form',
                            operator: null,
                            operatorRequired: false,
                            attribute: 'absli_fyc_individual_0amsodvw1e',
                            inputField: 'absli_fyc_individual_0amsodvw1e',
                          },
                        },
                        {
                          type: 'value',
                          value: {
                            val_type: 'static',
                            operator: null,
                            operatorRequired: false,
                            value: 12,
                            dataType: 'number',
                          },
                        },
                      ],
                      standardFunction: 'DIVIDE',
                      output: null,
                      returnType: 'number',
                    },
                  },
                },
              ],
              standardFunction: 'ROUND',
              output: null,
              returnType: 'number',
            },
          },
        },
      ],
      standardFunction: 'IS',
      output: null,
      returnType: 'number',
    },
  },
  {
    type: 'currency',
    code: 'absli_aum_traditional_chw0gfq6vo',
    hint: 'Average year AUM Traditional - Group Insurance Fund',
    required: false,
    max_chars: 19,
    read_only: false,
    display_in_form_type: 'MODULE',
    retain_form_context: true,
  },
  {
    type: 'decimal',
    code: 'absli_aum_traditional_points',
    hint: 'SELECT Points',
    required: false,
    read_only: true,
    display_in_form_type: 'MODULE',
    retain_form_context: true,
    default_value: {
      type: 'standard',
      inputs: [
        {
          type: 'value',
          value: {
            val_type: 'function',
            operator: null,
            operatorRequired: false,
            function: {
              type: 'standard',
              inputs: [
                {
                  type: 'value',
                  value: {
                    val_type: 'function',
                    operator: null,
                    operatorRequired: false,
                    function: {
                      type: 'standard',
                      inputs: [
                        {
                          type: 'value',
                          value: {
                            val_type: 'form',
                            operator: null,
                            operatorRequired: false,
                            attribute: 'absli_aum_traditional_chw0gfq6vo',
                            inputField: 'absli_aum_traditional_chw0gfq6vo',
                          },
                        },
                        {
                          type: 'value',
                          value: {
                            val_type: 'static',
                            operator: null,
                            operatorRequired: false,
                            value: 800,
                            dataType: 'number',
                          },
                        },
                      ],
                      standardFunction: 'DIVIDE',
                      output: null,
                      returnType: 'number',
                    },
                  },
                },
              ],
              standardFunction: 'ROUND',
              output: null,
              returnType: 'number',
            },
          },
        },
      ],
      standardFunction: 'IS',
      output: null,
      returnType: 'number',
    },
  },
  {
    type: 'currency',
    code: 'absli_aum_ulip_ru6jxvvlh',
    hint: 'Average year AUM ULIP - Group Insurance Fund',
    required: false,
    max_chars: 19,
    read_only: false,
    display_in_form_type: 'MODULE',
    retain_form_context: true,
  },
  {
    type: 'decimal',
    code: 'absli_aum_ulip_points',
    hint: 'SELECT Points',
    required: false,
    read_only: true,
    display_in_form_type: 'MODULE',
    retain_form_context: true,
    default_value: {
      type: 'standard',
      inputs: [
        {
          type: 'value',
          value: {
            val_type: 'function',
            operator: null,
            operatorRequired: false,
            function: {
              type: 'standard',
              inputs: [
                {
                  type: 'value',
                  value: {
                    val_type: 'function',
                    operator: null,
                    operatorRequired: false,
                    function: {
                      type: 'standard',
                      inputs: [
                        {
                          type: 'value',
                          value: {
                            val_type: 'form',
                            operator: null,
                            operatorRequired: false,
                            attribute: 'absli_aum_ulip_ru6jxvvlh',
                            inputField: 'absli_aum_ulip_ru6jxvvlh',
                          },
                        },
                        {
                          type: 'value',
                          value: {
                            val_type: 'static',
                            operator: null,
                            operatorRequired: false,
                            value: 1600,
                            dataType: 'number',
                          },
                        },
                      ],
                      standardFunction: 'DIVIDE',
                      output: null,
                      returnType: 'number',
                    },
                  },
                },
              ],
              standardFunction: 'ROUND',
              output: null,
              returnType: 'number',
            },
          },
        },
      ],
      standardFunction: 'IS',
      output: null,
      returnType: 'number',
    },
  },
  {
    type: 'currency',
    code: 'absli_fyp_term_ce29164mpp',
    hint: 'First Year Premium - Group Insurance Term',
    required: false,
    max_chars: 19,
    read_only: false,
    display_in_form_type: 'MODULE',
    retain_form_context: true,
  },
  {
    type: 'decimal',
    code: 'absli_fyp_term_points',
    hint: 'SELECT Points',
    required: false,
    read_only: true,
    display_in_form_type: 'MODULE',
    retain_form_context: true,
    default_value: {
      type: 'standard',
      inputs: [
        {
          type: 'value',
          value: {
            val_type: 'function',
            operator: null,
            operatorRequired: false,
            function: {
              type: 'standard',
              inputs: [
                {
                  type: 'value',
                  value: {
                    val_type: 'function',
                    operator: null,
                    operatorRequired: false,
                    function: {
                      type: 'standard',
                      inputs: [
                        {
                          type: 'value',
                          value: {
                            val_type: 'form',
                            operator: null,
                            operatorRequired: false,
                            attribute: 'absli_fyp_term_ce29164mpp',
                            inputField: 'absli_fyp_term_ce29164mpp',
                          },
                        },
                        {
                          type: 'value',
                          value: {
                            val_type: 'static',
                            operator: null,
                            operatorRequired: false,
                            value: 60,
                            dataType: 'number',
                          },
                        },
                      ],
                      standardFunction: 'DIVIDE',
                      output: null,
                      returnType: 'number',
                    },
                  },
                },
              ],
              standardFunction: 'ROUND',
              output: null,
              returnType: 'number',
            },
          },
        },
      ],
      standardFunction: 'IS',
      output: null,
      returnType: 'number',
    },
  },

  // ABHI Fields
  {
    type: 'currency',
    code: 'abhi_fyp_insurance_ff_input',
    hint: 'First Year Premium - Insurance',
    required: false,
    max_chars: 19,
    read_only: false,
    display_in_form_type: 'MODULE',
    retain_form_context: true,
  },
  {
    type: 'decimal',
    code: 'abhi_fyp_insurance_points',
    hint: 'SELECT Points',
    required: false,
    read_only: true,
    display_in_form_type: 'MODULE',
    retain_form_context: true,
    default_value: {
      type: 'standard',
      inputs: [
        {
          type: 'value',
          value: {
            val_type: 'function',
            operator: null,
            operatorRequired: false,
            function: {
              type: 'standard',
              inputs: [
                {
                  type: 'value',
                  value: {
                    val_type: 'function',
                    operator: null,
                    operatorRequired: false,
                    function: {
                      type: 'standard',
                      inputs: [
                        {
                          type: 'value',
                          value: {
                            val_type: 'form',
                            operator: null,
                            operatorRequired: false,
                            attribute: 'abhi_fyp_insurance_ff_input',
                            inputField: 'abhi_fyp_insurance_ff_input',
                          },
                        },
                        {
                          type: 'value',
                          value: {
                            val_type: 'static',
                            operator: null,
                            operatorRequired: false,
                            value: 38,
                            dataType: 'number',
                          },
                        },
                      ],
                      standardFunction: 'DIVIDE',
                      output: null,
                      returnType: 'number',
                    },
                  },
                },
              ],
              standardFunction: 'ROUND',
              output: null,
              returnType: 'number',
            },
          },
        },
      ],
      standardFunction: 'IS',
      output: null,
      returnType: 'number',
    },
  },
  {
    type: 'currency',
    code: 'abhi_fyp_group_session_context',
    hint: 'First Year Premium - Group Insurance',
    required: false,
    max_chars: 19,
    read_only: false,
    display_in_form_type: 'MODULE',
    retain_form_context: true,
  },
  {
    type: 'decimal',
    code: 'abhi_fyp_group_points',
    hint: 'SELECT Points',
    required: false,
    read_only: true,
    display_in_form_type: 'MODULE',
    retain_form_context: true,
    default_value: {
      type: 'standard',
      inputs: [
        {
          type: 'value',
          value: {
            val_type: 'function',
            operator: null,
            operatorRequired: false,
            function: {
              type: 'standard',
              inputs: [
                {
                  type: 'value',
                  value: {
                    val_type: 'function',
                    operator: null,
                    operatorRequired: false,
                    function: {
                      type: 'standard',
                      inputs: [
                        {
                          type: 'value',
                          value: {
                            val_type: 'form',
                            operator: null,
                            operatorRequired: false,
                            attribute: 'abhi_fyp_group_session_context',
                            inputField: 'abhi_fyp_group_session_context',
                          },
                        },
                        {
                          type: 'value',
                          value: {
                            val_type: 'static',
                            operator: null,
                            operatorRequired: false,
                            value: 700,
                            dataType: 'number',
                          },
                        },
                      ],
                      standardFunction: 'DIVIDE',
                      output: null,
                      returnType: 'number',
                    },
                  },
                },
              ],
              standardFunction: 'ROUND',
              output: null,
              returnType: 'number',
            },
          },
        },
      ],
      standardFunction: 'IS',
      output: null,
      returnType: 'number',
    },
  },

  // ABHFL Fields
  {
    type: 'currency',
    code: 'abhfl_loan_disbursed_input_a',
    hint: 'Loan disbursed - Home loan / LAP / Construction finance',
    required: false,
    max_chars: 19,
    read_only: false,
    display_in_form_type: 'MODULE',
    retain_form_context: true,
  },
  {
    type: 'decimal',
    code: 'abhfl_loan_disbursed_points',
    hint: 'SELECT Points',
    required: false,
    read_only: true,
    display_in_form_type: 'MODULE',
    retain_form_context: true,
    default_value: {
      type: 'standard',
      inputs: [
        {
          type: 'value',
          value: {
            val_type: 'function',
            operator: null,
            operatorRequired: false,
            function: {
              type: 'standard',
              inputs: [
                {
                  type: 'value',
                  value: {
                    val_type: 'function',
                    operator: null,
                    operatorRequired: false,
                    function: {
                      type: 'standard',
                      inputs: [
                        {
                          type: 'value',
                          value: {
                            val_type: 'form',
                            operator: null,
                            operatorRequired: false,
                            attribute: 'abhfl_loan_disbursed_input_a',
                            inputField: 'abhfl_loan_disbursed_input_a',
                          },
                        },
                        {
                          type: 'value',
                          value: {
                            val_type: 'static',
                            operator: null,
                            operatorRequired: false,
                            value: 700,
                            dataType: 'number',
                          },
                        },
                      ],
                      standardFunction: 'DIVIDE',
                      output: null,
                      returnType: 'number',
                    },
                  },
                },
              ],
              standardFunction: 'ROUND',
              output: null,
              returnType: 'number',
            },
          },
        },
      ],
      standardFunction: 'IS',
      output: null,
      returnType: 'number',
    },
  },

  // ABCL Fields
  {
    type: 'currency',
    code: 'abcl_loan_disbursed_c2vi4lxys8',
    hint: 'Loan disbursed - Retail Loan / SME / Mid Corporate',
    required: false,
    max_chars: 19,
    read_only: false,
    display_in_form_type: 'MODULE',
    retain_form_context: true,
  },
  {
    type: 'decimal',
    code: 'abcl_loan_disbursed_points',
    hint: 'SELECT Points',
    required: false,
    read_only: true,
    display_in_form_type: 'MODULE',
    retain_form_context: true,
    default_value: {
      type: 'standard',
      inputs: [
        {
          type: 'value',
          value: {
            val_type: 'function',
            operator: null,
            operatorRequired: false,
            function: {
              type: 'standard',
              inputs: [
                {
                  type: 'value',
                  value: {
                    val_type: 'function',
                    operator: null,
                    operatorRequired: false,
                    function: {
                      type: 'standard',
                      inputs: [
                        {
                          type: 'value',
                          value: {
                            val_type: 'form',
                            operator: null,
                            operatorRequired: false,
                            attribute: 'abcl_loan_disbursed_c2vi4lxys8',
                            inputField: 'abcl_loan_disbursed_c2vi4lxys8',
                          },
                        },
                        {
                          type: 'value',
                          value: {
                            val_type: 'static',
                            operator: null,
                            operatorRequired: false,
                            value: 700,
                            dataType: 'number',
                          },
                        },
                      ],
                      standardFunction: 'DIVIDE',
                      output: null,
                      returnType: 'number',
                    },
                  },
                },
              ],
              standardFunction: 'ROUND',
              output: null,
              returnType: 'number',
            },
          },
        },
      ],
      standardFunction: 'IS',
      output: null,
      returnType: 'number',
    },
  },
  {
    type: 'currency',
    code: 'abcl_ytd_outstanding_p79ec3vkpj',
    hint: 'YTD Average Outstanding book for the FY - Loan against Shares / Mutual Funds',
    required: false,
    max_chars: 19,
    read_only: false,
    display_in_form_type: 'MODULE',
    retain_form_context: true,
  },
  {
    type: 'decimal',
    code: 'abcl_ytd_outstanding_points',
    hint: 'SELECT Points',
    required: false,
    read_only: true,
    display_in_form_type: 'MODULE',
    retain_form_context: true,
    default_value: {
      type: 'standard',
      inputs: [
        {
          type: 'value',
          value: {
            val_type: 'function',
            operator: null,
            operatorRequired: false,
            function: {
              type: 'standard',
              inputs: [
                {
                  type: 'value',
                  value: {
                    val_type: 'function',
                    operator: null,
                    operatorRequired: false,
                    function: {
                      type: 'standard',
                      inputs: [
                        {
                          type: 'value',
                          value: {
                            val_type: 'form',
                            operator: null,
                            operatorRequired: false,
                            attribute: 'abcl_ytd_outstanding_p79ec3vkpj',
                            inputField: 'abcl_ytd_outstanding_p79ec3vkpj',
                          },
                        },
                        {
                          type: 'value',
                          value: {
                            val_type: 'static',
                            operator: null,
                            operatorRequired: false,
                            value: 700,
                            dataType: 'number',
                          },
                        },
                      ],
                      standardFunction: 'DIVIDE',
                      output: null,
                      returnType: 'number',
                    },
                  },
                },
              ],
              standardFunction: 'ROUND',
              output: null,
              returnType: 'number',
            },
          },
        },
      ],
      standardFunction: 'IS',
      output: null,
      returnType: 'number',
    },
  },

  // ABML Fields
  {
    type: 'currency',
    code: 'abml_equity_derivatives_9x2k',
    hint: 'Equity, Derivatives & Commodities - Gross Brokerage',
    required: false,
    max_chars: 19,
    read_only: false,
    display_in_form_type: 'MODULE',
    retain_form_context: true,
  },
  {
    type: 'decimal',
    code: 'abml_equity_derivatives_points',
    hint: 'SELECT Points',
    required: false,
    read_only: true,
    display_in_form_type: 'MODULE',
    retain_form_context: true,
    default_value: {
      type: 'standard',
      inputs: [
        {
          type: 'value',
          value: {
            val_type: 'function',
            operator: null,
            operatorRequired: false,
            function: {
              type: 'standard',
              inputs: [
                {
                  type: 'value',
                  value: {
                    val_type: 'function',
                    operator: null,
                    operatorRequired: false,
                    function: {
                      type: 'standard',
                      inputs: [
                        {
                          type: 'value',
                          value: {
                            val_type: 'form',
                            operator: null,
                            operatorRequired: false,
                            attribute: 'abml_equity_derivatives_9x2k',
                            inputField: 'abml_equity_derivatives_9x2k',
                          },
                        },
                        {
                          type: 'value',
                          value: {
                            val_type: 'static',
                            operator: null,
                            operatorRequired: false,
                            value: 70,
                            dataType: 'number',
                          },
                        },
                      ],
                      standardFunction: 'DIVIDE',
                      output: null,
                      returnType: 'number',
                    },
                  },
                },
              ],
              standardFunction: 'ROUND',
              output: null,
              returnType: 'number',
            },
          },
        },
      ],
      standardFunction: 'IS',
      output: null,
      returnType: 'number',
    },
  },
  {
    type: 'currency',
    code: 'abml_pms_book_7p5m',
    hint: 'Average monthly book outstanding - incremental over March 2025 - PMS',
    required: false,
    max_chars: 19,
    read_only: false,
    display_in_form_type: 'MODULE',
    retain_form_context: true,
  },
  {
    type: 'decimal',
    code: 'abml_pms_book_points',
    hint: 'SELECT Points',
    required: false,
    read_only: true,
    display_in_form_type: 'MODULE',
    retain_form_context: true,
    default_value: {
      type: 'standard',
      inputs: [
        {
          type: 'value',
          value: {
            val_type: 'function',
            operator: null,
            operatorRequired: false,
            function: {
              type: 'standard',
              inputs: [
                {
                  type: 'value',
                  value: {
                    val_type: 'function',
                    operator: null,
                    operatorRequired: false,
                    function: {
                      type: 'standard',
                      inputs: [
                        {
                          type: 'value',
                          value: {
                            val_type: 'form',
                            operator: null,
                            operatorRequired: false,
                            attribute: 'abml_pms_book_7p5m',
                            inputField: 'abml_pms_book_7p5m',
                          },
                        },
                        {
                          type: 'value',
                          value: {
                            val_type: 'static',
                            operator: null,
                            operatorRequired: false,
                            value: 800,
                            dataType: 'number',
                          },
                        },
                      ],
                      standardFunction: 'DIVIDE',
                      output: null,
                      returnType: 'number',
                    },
                  },
                },
              ],
              standardFunction: 'ROUND',
              output: null,
              returnType: 'number',
            },
          },
        },
      ],
      standardFunction: 'IS',
      output: null,
      returnType: 'number',
    },
  },
  {
    type: 'decimal',
    code: 'total_select_points',
    hint: 'Total SELECT Points',
    required: false,
    read_only: true,
    display_in_form_type: 'MODULE',
    retain_form_context: true,
    default_value: {
      type: 'standard',
      inputs: [
        {
          type: 'value',
          value: {
            val_type: 'form',
            operator: null,
            operatorRequired: false,
            attribute: 'absli_fyp_individual_points',
            inputField: 'absli_fyp_individual_points',
          },
        },
        {
          type: 'value',
          value: {
            val_type: 'form',
            operator: null,
            operatorRequired: false,
            attribute: 'absli_fyc_individual_points',
            inputField: 'absli_fyc_individual_points',
          },
        },
        {
          type: 'value',
          value: {
            val_type: 'form',
            operator: null,
            operatorRequired: false,
            attribute: 'absli_aum_traditional_points',
            inputField: 'absli_aum_traditional_points',
          },
        },
        {
          type: 'value',
          value: {
            val_type: 'form',
            operator: null,
            operatorRequired: false,
            attribute: 'absli_aum_ulip_points',
            inputField: 'absli_aum_ulip_points',
          },
        },
        {
          type: 'value',
          value: {
            val_type: 'form',
            operator: null,
            operatorRequired: false,
            attribute: 'absli_fyp_term_points',
            inputField: 'absli_fyp_term_points',
          },
        },
        {
          type: 'value',
          value: {
            val_type: 'form',
            operator: null,
            operatorRequired: false,
            attribute: 'abhi_fyp_insurance_points',
            inputField: 'abhi_fyp_insurance_points',
          },
        },
        {
          type: 'value',
          value: {
            val_type: 'form',
            operator: null,
            operatorRequired: false,
            attribute: 'abhi_fyp_group_points',
            inputField: 'abhi_fyp_group_points',
          },
        },
        {
          type: 'value',
          value: {
            val_type: 'form',
            operator: null,
            operatorRequired: false,
            attribute: 'abhfl_loan_disbursed_points',
            inputField: 'abhfl_loan_disbursed_points',
          },
        },
        {
          type: 'value',
          value: {
            val_type: 'form',
            operator: null,
            operatorRequired: false,
            attribute: 'abcl_loan_disbursed_points',
            inputField: 'abcl_loan_disbursed_points',
          },
        },
        {
          type: 'value',
          value: {
            val_type: 'form',
            operator: null,
            operatorRequired: false,
            attribute: 'abcl_ytd_outstanding_points',
            inputField: 'abcl_ytd_outstanding_points',
          },
        },
        {
          type: 'value',
          value: {
            val_type: 'form',
            operator: null,
            operatorRequired: false,
            attribute: 'abml_equity_derivatives_points',
            inputField: 'abml_equity_derivatives_points',
          },
        },
        {
          type: 'value',
          value: {
            val_type: 'form',
            operator: null,
            operatorRequired: false,
            attribute: 'abml_pms_book_points',
            inputField: 'abml_pms_book_points',
          },
        },
      ],
      standardFunction: 'SUM',
      output: null,
      returnType: 'number',
    },
  },
];
